// extracted by mini-css-extract-plugin
module.exports = {"slider-root":"Slider_slider-root__hVM0o"};